// Copyright (c) Docugami, Inc. All rights reserved.
/**
 * The supported feature flag IDs
 */
export enum FeatureFlags {
    DiagnosticLoggingEnabled = "DiagnosticLoggingEnabled",
    DownloadAllPipelineOutput = "DownloadAllPipelineOutput",
    DemoFeatures = "DemoFeatures",
    ChunkSourceDebugEnabled = "ChunkSourceDebugEnabled",
    DebugTokensEnabled = "DebugTokensEnabled",
    SdvDebugEnabled = "SdvDebugEnabled",
    ExperimentalFeatures = 'ExperimentalFeatures',
    ChatFeature = "ChatFeature",
    ChatStreaming = 'ChatStreaming',
    SdvCanvasEditor = "SdvCanvasEditor"
}

/**
 * The state of all existing feature flags
 */
export interface FeatureFlagState {
    featureFlags: { [id: string]: boolean };
}

/**
 * The payload used to set a feature flag
 */
export interface SetFeatureFlagPayload {
    featureFlag: FeatureFlags;
    value: boolean;
}

export const SET_FEATURE_FLAG = "SET_FEATURE_FLAG";

export interface SetFeatureFlag {
    type: typeof SET_FEATURE_FLAG;
    payload: SetFeatureFlagPayload;
}

export type FeatureFlagActionTypes =
    SetFeatureFlag;

export function getFeatureFlagKey(flag: FeatureFlags): string {
    return `featureFlag.${getFeatureFlagName(flag)}`;
}

export function getFeatureFlagName(flag: FeatureFlags): string {
    return FeatureFlags[flag];
}
